import { addDays, format, subDays } from "date-fns";

import type { CampaignDetails } from "../../src";
import { mockDataPrayers } from "./mockDataPrayers";
import { mockDateTime } from "./mockDateTime";

export const mockDataCampaign = {
  color: "rgb(59, 4, 107)",
  imgSrc: { large: "https://images.hallow.app/covers/81_xl.webp" },
  illustrationImgSrc: "https://images.hallow.app/covers/81_xl.webp",
} as const;

export const mockDataCampaignDetails: CampaignDetails = {
  campaign: {
    id: 3,
    name: "Pray for Bob",
    description: "Bob needs prayer",
    starts_at: mockDateTime(new Date()),
    ends_at: mockDateTime(addDays(new Date(), 7)),
    organizer: {},
    labels: ["label"],
    status: "ACTIVE",
    content_title: "Daily Rosary",
    is_hallow_campaign: false,
    sessions_prayed: 0,
    has_joined: false,
    image: { large: "https://images.hallow.app/covers/37_xl.webp" },
    content_image: { large: "https://images.hallow.app/covers/81_xl.webp" },
    giving: null,
  },
  playlist_content: [
    {
      id: 5,
      date: format(new Date(), "yyyy-MM-dd"),
      content_type: "prayer",
      content: mockDataPrayers[0],
    },
  ],
  community: null,
  latest_posts: [],
  updates: [],
};

export const mockDataGivingCampaignDetails: CampaignDetails = {
  ...mockDataCampaignDetails,
  campaign: {
    ...mockDataCampaignDetails.campaign,
    id: 5,
    giving: {
      id: 12,
      published_at: mockDateTime(subDays(new Date(), 10)),
      goal_amount: 5000,
      hallow_match: {
        max_amount: 2500,
        current_amount: 1000,
        description: "match",
      },
      current_amount_of_all_successful_and_pending_payments: 1000,
      current_total_raised_including_match: 2000,
      number_of_donations: 37,
    },
  },
};
